import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-header',
  templateUrl: './dashboard-header.component.html',
  styleUrls: ['./dashboard-header.component.css']
})
export class DashboardHeaderComponent implements OnInit {
  LogoNL: boolean;
  LogoFR: boolean;
  @Input() defaultLanguage;
  @Input() federaleURL;
  logoPath = 'assets/icons/logo.svg';
  selectLanguage: boolean;
  selectedLanguage;
  welcome: string;

  constructor(private translate: TranslateService, private _router: Router) { }

  ngOnInit(): void {
    var currentlang = sessionStorage.getItem("currentlang")
    this.switchLang(currentlang);
    if (currentlang == 'FR') {
     
      this.LogoFR = true;
      this.LogoNL = false;
    }
    else {
      this.LogoFR = false;
      this.LogoNL = true;
    }
  }

  changeLanguage() {

    if (this.translate.currentLang == 'FR') {
      this.defaultLanguage = "NL";
      this.LogoFR = false;
      this.LogoNL = true;
      sessionStorage.setItem("currentlang", "NL")
      sessionStorage.setItem("presentLang", "Even geduld, we zijn uw gegevens aan het laden");
    } else {
      this.defaultLanguage = "FR";
      this.LogoFR = true;
      this.LogoNL = false;
      sessionStorage.setItem("currentlang", "FR")
      sessionStorage.setItem("presentLang", "Veuillez patienter svp, nous chargeons vos données");
    }
    this.switchLang(this.defaultLanguage);
  }

  switchLang(lang: string) {
    this.defaultLanguage = lang;
    if (lang == 'FR') {
      this.LogoFR = true;
      this.LogoNL = false;
    }
    else {
      this.LogoFR = false;
      this.LogoNL = true;
    }
    this.translate.use(lang);

  }
  logOut() {
    var currentlang = sessionStorage.getItem("currentlang")
    sessionStorage.clear();
    sessionStorage.setItem("currentlang", currentlang);
    sessionStorage.setItem("checktoReload", "true");
    this._router.navigate(['']);

  }
}
